import x, { useState as ut, useEffect as ft, useMemo as dt, forwardRef as Oe } from "react";
import { c as pt, f as bt } from "./index8.js";
import { Y as gt, j as mt, O as yt, f as ht } from "./index13.js";
import { E as vt } from "./index9.js";
import { r as fe, b as de, m as s, E as J, F as m, C as F, A, h as O, L as R, v as Yn, w as ke, z as ce, M as xt, j as U, p as Z, o as T, d as Ot, O as jt, t as Jn, N as wt } from "./index2.js";
import { c as pe, g as be } from "./jsx-runtime.js";
import { V as kt } from "./index6.js";
import { v as K, e as je, l as Q, a as we } from "./index4.js";
var Kn = { exports: {} };
(function(n, o) {
  (function(t, i) {
    n.exports = i(x, fe(), de);
  })(pe, function(t, i, c) {
    function u(e) {
      return e && typeof e == "object" && "default" in e ? e : { default: e };
    }
    function b(e) {
      if (e && typeof e == "object" && "default" in e)
        return e;
      var r = /* @__PURE__ */ Object.create(null);
      return e && Object.keys(e).forEach(function(a) {
        if (a !== "default") {
          var l = Object.getOwnPropertyDescriptor(e, a);
          Object.defineProperty(r, a, l.get ? l : { enumerable: !0, get: function() {
            return e[a];
          } });
        }
      }), r.default = e, Object.freeze(r);
    }
    var g = b(t), f = u(i);
    function h(e) {
      var r = function(a, l) {
        if (typeof a != "object" || !a)
          return a;
        var j = a[Symbol.toPrimitive];
        if (j !== void 0) {
          var w = j.call(a, l || "default");
          if (typeof w != "object")
            return w;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (l === "string" ? String : Number)(a);
      }(e, "string");
      return typeof r == "symbol" ? r : r + "";
    }
    function p(e, r, a) {
      return (r = h(r)) in e ? Object.defineProperty(e, r, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = a, e;
    }
    function y() {
      return y = Object.assign ? Object.assign.bind() : function(e) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var l in a)
            Object.prototype.hasOwnProperty.call(a, l) && (e[l] = a[l]);
        }
        return e;
      }, y.apply(this, arguments);
    }
    function z(e, r) {
      if (e == null)
        return {};
      var a, l, j = function(E, L) {
        if (E == null)
          return {};
        var k, N, S = {}, P = Object.keys(E);
        for (N = 0; N < P.length; N++)
          k = P[N], L.indexOf(k) >= 0 || (S[k] = E[k]);
        return S;
      }(e, r);
      if (Object.getOwnPropertySymbols) {
        var w = Object.getOwnPropertySymbols(e);
        for (l = 0; l < w.length; l++)
          a = w[l], r.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (j[a] = e[a]);
      }
      return j;
    }
    function C(e, r) {
      return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(r) } }));
    }
    var M, D, H = { small: 14, default: 16, large: 20, xlarge: 24 }, q = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], $ = function(e) {
      var r = e.className, a = e.size, l = a === void 0 ? 16 : a, j = e.title, w = e["aria-label"], E = e["aria-labelledby"], L = e.fill, k = e.role, N = k === void 0 ? "img" : k, S = z(e, q), P = c.css(M || (M = C([`
        color: `, `;
      `])), L), ee = c.css(D || (D = C([`
        flex-shrink: 0;
      `]))), ne = function(te, re, B) {
        var V, _ = B["aria-label"], G = B["aria-labelledby"], W = B.title;
        switch (te) {
          case "img":
            return _ || G || W ? p(p(p({}, "aria-labelledby", G), "aria-label", _), "title", W) : { "aria-label": (V = re, "".concat(V.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(N, "X", p(p({ title: j }, "aria-label", w), "aria-labelledby", E));
      return g.createElement("svg", y({ className: c.cx(p({}, P, L != null), ee, r), height: typeof l == "number" ? l : H[l], width: typeof l == "number" ? l : H[l], role: N }, ne, S, { viewBox: "0 0 16 16" }), g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.2028 3.40381C11.8123 3.01329 11.1791 3.01329 10.7886 3.40381L8.3137 5.87869L5.83883 3.40381C5.44831 3.01329 4.81514 3.01329 4.42462 3.40381L3.71751 4.11092C3.32699 4.50144 3.32699 5.13461 3.71751 5.52513L6.19238 8.00001L3.71751 10.4749C3.32699 10.8654 3.32699 11.4986 3.71751 11.8891L4.42462 12.5962C4.81514 12.9867 5.44831 12.9867 5.83883 12.5962L8.3137 10.1213L10.7886 12.5962C11.1791 12.9867 11.8123 12.9867 12.2028 12.5962L12.9099 11.8891C13.3004 11.4986 13.3004 10.8654 12.9099 10.4749L10.435 8.00001L12.9099 5.52513C13.3004 5.13461 13.3004 4.50144 12.9099 4.11092L12.2028 3.40381Z", fill: "currentColor" }));
    };
    return $.displayName = "X", $.isGlyph = !0, $.propTypes = { fill: f.default.string, size: f.default.oneOfType([f.default.number, f.default.string]), className: f.default.string }, $;
  });
})(Kn);
var Nt = Kn.exports;
const Ct = /* @__PURE__ */ be(Nt);
var Qn = { exports: {} };
(function(n, o) {
  (function(t, i) {
    n.exports = i(x, fe(), de);
  })(pe, function(t, i, c) {
    function u(e) {
      return e && typeof e == "object" && "default" in e ? e : { default: e };
    }
    function b(e) {
      if (e && typeof e == "object" && "default" in e)
        return e;
      var r = /* @__PURE__ */ Object.create(null);
      return e && Object.keys(e).forEach(function(a) {
        if (a !== "default") {
          var l = Object.getOwnPropertyDescriptor(e, a);
          Object.defineProperty(r, a, l.get ? l : { enumerable: !0, get: function() {
            return e[a];
          } });
        }
      }), r.default = e, Object.freeze(r);
    }
    var g = b(t), f = u(i);
    function h(e) {
      var r = function(a, l) {
        if (typeof a != "object" || !a)
          return a;
        var j = a[Symbol.toPrimitive];
        if (j !== void 0) {
          var w = j.call(a, l || "default");
          if (typeof w != "object")
            return w;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (l === "string" ? String : Number)(a);
      }(e, "string");
      return typeof r == "symbol" ? r : r + "";
    }
    function p(e, r, a) {
      return (r = h(r)) in e ? Object.defineProperty(e, r, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = a, e;
    }
    function y() {
      return y = Object.assign ? Object.assign.bind() : function(e) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var l in a)
            Object.prototype.hasOwnProperty.call(a, l) && (e[l] = a[l]);
        }
        return e;
      }, y.apply(this, arguments);
    }
    function z(e, r) {
      if (e == null)
        return {};
      var a, l, j = function(E, L) {
        if (E == null)
          return {};
        var k, N, S = {}, P = Object.keys(E);
        for (N = 0; N < P.length; N++)
          k = P[N], L.indexOf(k) >= 0 || (S[k] = E[k]);
        return S;
      }(e, r);
      if (Object.getOwnPropertySymbols) {
        var w = Object.getOwnPropertySymbols(e);
        for (l = 0; l < w.length; l++)
          a = w[l], r.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (j[a] = e[a]);
      }
      return j;
    }
    function C(e, r) {
      return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(r) } }));
    }
    var M, D, H = { small: 14, default: 16, large: 20, xlarge: 24 }, q = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], $ = function(e) {
      var r = e.className, a = e.size, l = a === void 0 ? 16 : a, j = e.title, w = e["aria-label"], E = e["aria-labelledby"], L = e.fill, k = e.role, N = k === void 0 ? "img" : k, S = z(e, q), P = c.css(M || (M = C([`
        color: `, `;
      `])), L), ee = c.css(D || (D = C([`
        flex-shrink: 0;
      `]))), ne = function(te, re, B) {
        var V, _ = B["aria-label"], G = B["aria-labelledby"], W = B.title;
        switch (te) {
          case "img":
            return _ || G || W ? p(p(p({}, "aria-labelledby", G), "aria-label", _), "title", W) : { "aria-label": (V = re, "".concat(V.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(N, "ArrowLeft", p(p({ title: j }, "aria-label", w), "aria-labelledby", E));
      return g.createElement("svg", y({ className: c.cx(p({}, P, L != null), ee, r), height: typeof l == "number" ? l : H[l], width: typeof l == "number" ? l : H[l], role: N }, ne, S, { viewBox: "0 0 16 16" }), g.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return $.displayName = "ArrowLeft", $.isGlyph = !0, $.propTypes = { fill: f.default.string, size: f.default.oneOfType([f.default.number, f.default.string]), className: f.default.string }, $;
  });
})(Qn);
var zt = Qn.exports;
const Et = /* @__PURE__ */ be(zt);
var et = { exports: {} };
(function(n, o) {
  (function(t, i) {
    n.exports = i(x, fe(), de);
  })(pe, function(t, i, c) {
    function u(e) {
      return e && typeof e == "object" && "default" in e ? e : { default: e };
    }
    function b(e) {
      if (e && typeof e == "object" && "default" in e)
        return e;
      var r = /* @__PURE__ */ Object.create(null);
      return e && Object.keys(e).forEach(function(a) {
        if (a !== "default") {
          var l = Object.getOwnPropertyDescriptor(e, a);
          Object.defineProperty(r, a, l.get ? l : { enumerable: !0, get: function() {
            return e[a];
          } });
        }
      }), r.default = e, Object.freeze(r);
    }
    var g = b(t), f = u(i);
    function h(e) {
      var r = function(a, l) {
        if (typeof a != "object" || !a)
          return a;
        var j = a[Symbol.toPrimitive];
        if (j !== void 0) {
          var w = j.call(a, l || "default");
          if (typeof w != "object")
            return w;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (l === "string" ? String : Number)(a);
      }(e, "string");
      return typeof r == "symbol" ? r : r + "";
    }
    function p(e, r, a) {
      return (r = h(r)) in e ? Object.defineProperty(e, r, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = a, e;
    }
    function y() {
      return y = Object.assign ? Object.assign.bind() : function(e) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var l in a)
            Object.prototype.hasOwnProperty.call(a, l) && (e[l] = a[l]);
        }
        return e;
      }, y.apply(this, arguments);
    }
    function z(e, r) {
      if (e == null)
        return {};
      var a, l, j = function(E, L) {
        if (E == null)
          return {};
        var k, N, S = {}, P = Object.keys(E);
        for (N = 0; N < P.length; N++)
          k = P[N], L.indexOf(k) >= 0 || (S[k] = E[k]);
        return S;
      }(e, r);
      if (Object.getOwnPropertySymbols) {
        var w = Object.getOwnPropertySymbols(e);
        for (l = 0; l < w.length; l++)
          a = w[l], r.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (j[a] = e[a]);
      }
      return j;
    }
    function C(e, r) {
      return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(r) } }));
    }
    var M, D, H = { small: 14, default: 16, large: 20, xlarge: 24 }, q = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], $ = function(e) {
      var r = e.className, a = e.size, l = a === void 0 ? 16 : a, j = e.title, w = e["aria-label"], E = e["aria-labelledby"], L = e.fill, k = e.role, N = k === void 0 ? "img" : k, S = z(e, q), P = c.css(M || (M = C([`
        color: `, `;
      `])), L), ee = c.css(D || (D = C([`
        flex-shrink: 0;
      `]))), ne = function(te, re, B) {
        var V, _ = B["aria-label"], G = B["aria-labelledby"], W = B.title;
        switch (te) {
          case "img":
            return _ || G || W ? p(p(p({}, "aria-labelledby", G), "aria-label", _), "title", W) : { "aria-label": (V = re, "".concat(V.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(N, "ArrowRight", p(p({ title: j }, "aria-label", w), "aria-labelledby", E));
      return g.createElement("svg", y({ className: c.cx(p({}, P, L != null), ee, r), height: typeof l == "number" ? l : H[l], width: typeof l == "number" ? l : H[l], role: N }, ne, S, { viewBox: "0 0 16 16" }), g.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return $.displayName = "ArrowRight", $.isGlyph = !0, $.propTypes = { fill: f.default.string, size: f.default.oneOfType([f.default.number, f.default.string]), className: f.default.string }, $;
  });
})(et);
var $t = et.exports;
const Lt = /* @__PURE__ */ be($t);
var nt = { exports: {} };
(function(n, o) {
  (function(t, i) {
    n.exports = i(x, fe(), de);
  })(pe, function(t, i, c) {
    function u(e) {
      return e && typeof e == "object" && "default" in e ? e : { default: e };
    }
    function b(e) {
      if (e && typeof e == "object" && "default" in e)
        return e;
      var r = /* @__PURE__ */ Object.create(null);
      return e && Object.keys(e).forEach(function(a) {
        if (a !== "default") {
          var l = Object.getOwnPropertyDescriptor(e, a);
          Object.defineProperty(r, a, l.get ? l : { enumerable: !0, get: function() {
            return e[a];
          } });
        }
      }), r.default = e, Object.freeze(r);
    }
    var g = b(t), f = u(i);
    function h(e) {
      var r = function(a, l) {
        if (typeof a != "object" || !a)
          return a;
        var j = a[Symbol.toPrimitive];
        if (j !== void 0) {
          var w = j.call(a, l || "default");
          if (typeof w != "object")
            return w;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (l === "string" ? String : Number)(a);
      }(e, "string");
      return typeof r == "symbol" ? r : r + "";
    }
    function p(e, r, a) {
      return (r = h(r)) in e ? Object.defineProperty(e, r, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = a, e;
    }
    function y() {
      return y = Object.assign ? Object.assign.bind() : function(e) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var l in a)
            Object.prototype.hasOwnProperty.call(a, l) && (e[l] = a[l]);
        }
        return e;
      }, y.apply(this, arguments);
    }
    function z(e, r) {
      if (e == null)
        return {};
      var a, l, j = function(E, L) {
        if (E == null)
          return {};
        var k, N, S = {}, P = Object.keys(E);
        for (N = 0; N < P.length; N++)
          k = P[N], L.indexOf(k) >= 0 || (S[k] = E[k]);
        return S;
      }(e, r);
      if (Object.getOwnPropertySymbols) {
        var w = Object.getOwnPropertySymbols(e);
        for (l = 0; l < w.length; l++)
          a = w[l], r.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (j[a] = e[a]);
      }
      return j;
    }
    function C(e, r) {
      return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(r) } }));
    }
    var M, D, H = { small: 14, default: 16, large: 20, xlarge: 24 }, q = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], $ = function(e) {
      var r = e.className, a = e.size, l = a === void 0 ? 16 : a, j = e.title, w = e["aria-label"], E = e["aria-labelledby"], L = e.fill, k = e.role, N = k === void 0 ? "img" : k, S = z(e, q), P = c.css(M || (M = C([`
        color: `, `;
      `])), L), ee = c.css(D || (D = C([`
        flex-shrink: 0;
      `]))), ne = function(te, re, B) {
        var V, _ = B["aria-label"], G = B["aria-labelledby"], W = B.title;
        switch (te) {
          case "img":
            return _ || G || W ? p(p(p({}, "aria-labelledby", G), "aria-label", _), "title", W) : { "aria-label": (V = re, "".concat(V.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(N, "OpenNewTab", p(p({ title: j }, "aria-label", w), "aria-labelledby", E));
      return g.createElement("svg", y({ className: c.cx(p({}, P, L != null), ee, r), height: typeof l == "number" ? l : H[l], width: typeof l == "number" ? l : H[l], role: N }, ne, S, { viewBox: "0 0 16 16" }), g.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), g.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return $.displayName = "OpenNewTab", $.isGlyph = !0, $.propTypes = { fill: f.default.string, size: f.default.oneOfType([f.default.number, f.default.string]), className: f.default.string }, $;
  });
})(nt);
var St = nt.exports;
const Pt = /* @__PURE__ */ be(St);
function Mt(n) {
  var o = function(t, i) {
    if (typeof t != "object" || !t)
      return t;
    var c = t[Symbol.toPrimitive];
    if (c !== void 0) {
      var u = c.call(t, i || "default");
      if (typeof u != "object")
        return u;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (i === "string" ? String : Number)(t);
  }(n, "string");
  return typeof o == "symbol" ? o : o + "";
}
function v(n, o, t) {
  return (o = Mt(o)) in n ? Object.defineProperty(n, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[o] = t, n;
}
function I() {
  return I = Object.assign ? Object.assign.bind() : function(n) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
    }
    return n;
  }, I.apply(this, arguments);
}
function X(n, o) {
  if (n == null)
    return {};
  var t, i, c = function(b, g) {
    if (b == null)
      return {};
    var f, h, p = {}, y = Object.keys(b);
    for (h = 0; h < y.length; h++)
      f = y[h], g.indexOf(f) >= 0 || (p[f] = b[f]);
    return p;
  }(n, o);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(n);
    for (i = 0; i < u.length; i++)
      t = u[i], o.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (c[t] = n[t]);
  }
  return c;
}
function d(n, o) {
  return o || (o = n.slice(0)), Object.freeze(Object.defineProperties(n, { raw: { value: Object.freeze(o) } }));
}
function Dt(n, o) {
  return function(t) {
    if (Array.isArray(t))
      return t;
  }(n) || function(t, i) {
    var c = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (c != null) {
      var u, b, g, f, h = [], p = !0, y = !1;
      try {
        if (g = (c = c.call(t)).next, i === 0) {
          if (Object(c) !== c)
            return;
          p = !1;
        } else
          for (; !(p = (u = g.call(c)).done) && (h.push(u.value), h.length !== i); p = !0)
            ;
      } catch (z) {
        y = !0, b = z;
      } finally {
        try {
          if (!p && c.return != null && (f = c.return(), Object(f) !== f))
            return;
        } finally {
          if (y)
            throw b;
        }
      }
      return h;
    }
  }(n, o) || function(t, i) {
    if (t) {
      if (typeof t == "string")
        return Ne(t, i);
      var c = Object.prototype.toString.call(t).slice(8, -1);
      if (c === "Object" && t.constructor && (c = t.constructor.name), c === "Map" || c === "Set")
        return Array.from(t);
      if (c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c))
        return Ne(t, i);
    }
  }(n, o) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Ne(n, o) {
  (o == null || o > n.length) && (o = n.length);
  for (var t = 0, i = new Array(o); t < o; t++)
    i[t] = n[t];
  return i;
}
var Ce, ze, Ee, $e, Le, Se, Pe, Me, oe = s(Ce || (Ce = d([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), J.default, m.black), tt = v(v({}, A.Body1, s(ze || (ze = d([`
    font-size: `, `px;
    line-height: `, `px;
  `])), F.body1.fontSize, F.body1.lineHeight)), A.Body2, s(Ee || (Ee = d([`
    font-size: `, `px;
    line-height: `, `px;
  `])), F.body2.fontSize, F.body2.lineHeight)), Ft = v(v({}, A.Body1, s($e || ($e = d([`
    font-size: `, `px;
    line-height: `, `px;
  `])), F.code1.fontSize, F.code1.lineHeight)), A.Body2, s(Le || (Le = d([`
    font-size: `, `px;
    line-height: `, `px;
  `])), F.code2.fontSize, F.code2.lineHeight)), ge = v(v({}, O.Light, s(Se || (Se = d([`
    color: `, `;
  `])), m.black)), O.Dark, s(Pe || (Pe = d([`
    color: `, `;
  `])), m.gray.light2)), ie = function(n) {
  var o = Ot();
  return n ? n === 16 ? A.Body2 : A.Body1 : o === 16 ? A.Body2 : A.Body1;
}, Tt = ["baseFontSize", "darkMode", "className", "weight", "as"], rt = K(function(n) {
  var o = n.baseFontSize, t = n.darkMode, i = n.className, c = n.weight, u = c === void 0 ? "regular" : c, b = n.as, g = b === void 0 ? "p" : b, f = X(n, Tt), h = Z(t).theme, p = ie(o), y = Q(g).Component, z = s(Me || (Me = d([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), R[u], R.bold);
  return x.createElement(y, I({ className: T(oe, tt[p], ge[h], z, i) }, f));
});
rt.displayName = "Body";
var De, Fe, Te, Be, Ae, He, Ie, Ze, Re, Ve, Bt = { label: "lg-label", description: "lg-description" };
s(De || (De = d([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), J.default, R.regular);
v(v({}, O.Light, s(Fe || (Fe = d([`
    color: `, `;
  `])), m.gray.dark1)), O.Dark, s(Te || (Te = d([`
    color: `, `;
  `])), m.gray.light1));
v(v({}, O.Light, s(Be || (Be = d([`
    color: `, `;
  `])), m.gray.base)), O.Dark, s(Ae || (Ae = d([`
    color: `, `;
  `])), m.gray.dark1));
v(v({}, A.Body1, s(He || (He = d([`
    font-size: `, `px;
    line-height: `, `px;
  `])), F.body1.fontSize, F.body1.lineHeight)), A.Body2, s(Ie || (Ie = d([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), F.body2.fontSize));
var _e, Ge, We, Xe, qe;
v(v({}, O.Light, s(Ze || (Ze = d([`
    color: `, `;
  `])), m.gray.dark1)), O.Dark, s(Re || (Re = d([`
    color: `, `;
  `])), m.gray.light1));
s(Ve || (Ve = d([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var Ue, Ye, Je, Ke, Qe, en, At = s(_e || (_e = d([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), J.default, R.regular), Ht = v(v({}, O.Light, s(Ge || (Ge = d([`
    color: `, `;
  `])), m.red.base)), O.Dark, s(We || (We = d([`
    color: `, `;
  `])), m.red.light1)), It = v(v({}, A.Body1, s(Xe || (Xe = d([`
    font-size: `, `px;
    line-height: `, `px;
  `])), F.body1.fontSize, F.body1.lineHeight)), A.Body2, s(qe || (qe = d([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), F.body2.fontSize)), Zt = ["as", "darkMode", "children", "className"];
K(function(n) {
  var o = n.as, t = o === void 0 ? "p" : o, i = n.darkMode, c = n.children, u = n.className, b = X(n, Zt), g = Z(i).theme, f = ie(), h = Q(t).Component;
  return x.createElement(h, I({}, b, { className: T(At, Ht[g], It[f], u) }), c);
});
var Rt = s(Ue || (Ue = d([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), R.regular, J.serif), Vt = v(v({}, O.Light, s(Ye || (Ye = d([`
    color: `, `;
  `])), m.green.dark2)), O.Dark, s(Je || (Je = d([`
    color: `, `;
  `])), m.gray.light2)), _t = ["darkMode", "className", "as"], Gt = K(function(n) {
  var o = n.darkMode, t = n.className, i = n.as, c = i === void 0 ? "h1" : i, u = X(n, _t), b = Z(o).theme, g = Q(c).Component;
  return x.createElement(g, I({ className: T(oe, Rt, Vt[b], t) }, u));
});
Gt.displayName = "H1";
var nn, Wt = s(Ke || (Ke = d([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), R.regular, J.serif), Xt = v(v({}, O.Light, s(Qe || (Qe = d([`
    color: `, `;
  `])), m.green.dark2)), O.Dark, s(en || (en = d([`
    color: `, `;
  `])), m.gray.light2)), qt = ["darkMode", "className", "as"], Ut = K(function(n) {
  var o = n.darkMode, t = n.className, i = n.as, c = i === void 0 ? "h2" : i, u = X(n, qt), b = Z(o).theme, g = Q(c).Component;
  return x.createElement(g, I({ className: T(oe, Wt, Xt[b], t) }, u));
});
Ut.displayName = "H2";
var tn, rn, an, on, ln, cn, sn, un, fn, dn, Yt = s(nn || (nn = d([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), R.medium), Jt = ["darkMode", "className", "as"], Kt = K(function(n) {
  var o = n.darkMode, t = n.className, i = n.as, c = i === void 0 ? "h3" : i, u = X(n, Jt), b = Z(o).theme, g = Q(c).Component;
  return x.createElement(g, I({ className: T(oe, Yt, ge[b], t) }, u));
});
Kt.displayName = "H3";
var pn, bn, gn, ae = Yn(), Qt = s(tn || (tn = d([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), J.code, ae), er = v(v({}, O.Light, s(rn || (rn = d([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), m.gray.light3, m.gray.light2, m.gray.dark3, ae, m.gray.light2, m.gray.light1)), O.Dark, s(an || (an = d([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), m.gray.dark2, m.gray.light1, ae, m.gray.dark2, m.gray.dark1)), nr = v(v({}, O.Light, s(on || (on = d([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), ae, ke[O.Light].default, m.blue.base)), O.Dark, s(ln || (ln = d([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), ae, ke[O.Dark].default, m.blue.base)), tr = v(v({}, O.Light, s(cn || (cn = d([`
    color: `, `;
  `])), m.blue.base)), O.Dark, s(sn || (sn = d([`
    color: `, `;
  `])), m.blue.light1)), rr = s(un || (un = d([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), ar = s(fn || (fn = d([`
  white-space: nowrap;
`]))), or = s(dn || (dn = d([`
  white-space: normal;
`]))), ir = ["children", "className", "darkMode", "baseFontSize", "as"], mn = je(function(n, o) {
  var t, i, c = n.children, u = n.className, b = n.darkMode, g = n.baseFontSize, f = n.as, h = X(n, ir), p = Z(b).theme, y = ie(g), z = we(f, h, "code").Component, C = ((t = typeof c == "string" && ((i = c.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || i === void 0 ? void 0 : i.length)) !== null && t !== void 0 ? t : 0) <= 30 ? ar : or, M = z !== "code", D = x.createElement("code", { ref: o, className: T(Ft[y], Qt, er[p], nr[p], C, v({}, tr[p], M), u) }, c);
  return M ? x.createElement(z, I({ className: T(ae, rr, u) }, h), D) : x.cloneElement(D, h);
});
mn.displayName = "InlineCode", mn.propTypes = { children: ce.node, className: ce.string, darkMode: ce.bool, baseFontSize: ce.oneOf(Object.values(A)) };
var yn, hn, vn, xn, On, jn, wn;
s(pn || (pn = d([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), J.code);
v(v({}, O.Light, s(bn || (bn = d([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), m.black, m.gray.dark3, m.white)), O.Dark, s(gn || (gn = d([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), m.gray.light2, m.gray.base, m.gray.dark3));
var kn, Nn, Cn, lr = s(yn || (yn = d([`
  font-family: `, `;
  font-weight: `, `;
`])), J.default, R.bold), cr = v(v({}, O.Light, s(hn || (hn = d([`
    color: `, `;
  `])), m.black)), O.Dark, s(vn || (vn = d([`
    color: `, `;
  `])), m.gray.light2)), sr = v(v({}, O.Light, s(xn || (xn = d([`
    color: `, `;
  `])), m.gray.base)), O.Dark, s(On || (On = d([`
    color: `, `;
  `])), m.gray.dark1)), ur = v(v({}, A.Body1, s(jn || (jn = d([`
    font-size: `, `px;
    line-height: `, `px;
  `])), F.body1.fontSize, F.body1.lineHeight)), A.Body2, s(wn || (wn = d([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), F.body2.fontSize)), fr = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], dr = K(function(n) {
  var o = n.baseFontSize, t = n.darkMode, i = n.className, c = n.children, u = n.disabled, b = u !== void 0 && u, g = n.as, f = g === void 0 ? "label" : g, h = n["data-lgid"], p = h === void 0 ? Bt.label : h, y = X(n, fr), z = Z(t).theme, C = ie(o), M = Q(f).Component;
  return x.createElement(M, I({ "data-lgid": p, className: T(lr, cr[z], ur[C], v({}, sr[z], b), i) }, y), c);
});
dr.displayName = "Label";
var zn, En, $n, Ln, Sn, Pn, se = Yn(), at = s(kn || (kn = d([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), J.default, xt.default), ot = v(v({}, O.Light, s(Nn || (Nn = d([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), m.blue.base, R.regular, m.gray.light2, m.blue.base)), O.Dark, s(Cn || (Cn = d([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), m.blue.light1, R.bold, m.gray.dark2, m.blue.base)), it = function(n) {
  if (n)
    return tt[n];
}, pr = s(zn || (zn = d([`
  gap: `, `px;
  display: inline-flex;
`])), U[100]), br = ["children", "className", "baseFontSize", "darkMode", "as"];
je(function(n, o) {
  var t = n.children, i = n.className, c = n.baseFontSize, u = n.darkMode, b = n.as, g = X(n, br), f = Z(u).theme, h = ie(c), p = we(b, g, "span").Component;
  return x.createElement(p, I({ className: T(se, at, it(h), ot[f], pr, i), ref: o }, g), x.createElement(Et, { role: "presentation" }), t);
});
var gr = s(En || (En = d([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), mr = s($n || ($n = d([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), se, se), yr = s(Ln || (Ln = d([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), hr = "hover", vr = "persist", Mn = "none", xr = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
je(function(n, o) {
  var t = n.children, i = n.className, c = n.arrowAppearance, u = c === void 0 ? Mn : c, b = n.hideExternalIcon, g = b !== void 0 && b, f = n.baseFontSize, h = n.darkMode, p = n.as, y = X(n, xr), z = Dt(ut(""), 2), C = z[0], M = z[1];
  ft(function() {
    M(window.location.hostname);
  }, []);
  var D, H = Z(h).theme, q = ie(f), $ = we(p, y, "span").Component, e = dt(function() {
    if (y.href !== void 0)
      return /^http(s)?:\/\//.test(y.href) ? new URL(y.href).hostname : C;
  }, [y, C]), r = { target: void 0, rel: void 0 };
  return y.target || y.rel ? (r.target = y.target, r.rel = y.rel) : $ === "a" && (e === C ? r.target = "_self" : (r.target = "_blank", r.rel = "noopener noreferrer")), r.target !== "_blank" || g ? u !== Mn && (D = x.createElement(Lt, { role: "presentation", size: 12, className: T(v(v({}, mr, u === hr), gr, u === vr)) })) : D = x.createElement(Pt, { role: "presentation", className: yr }), x.createElement($, I({ className: T(se, at, it(q), ot[H], i), ref: o }, r, y), x.createElement("span", null, t), D);
});
var Or = s(Sn || (Sn = d([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), R.bold), jr = ["darkMode", "className", "as"], wr = K(function(n) {
  var o = n.darkMode, t = n.className, i = n.as, c = i === void 0 ? "div" : i, u = X(n, jr), b = Z(o).theme, g = Q(c).Component;
  return x.createElement(g, I({ className: T(oe, Or, ge[b], t) }, u));
});
wr.displayName = "Overline";
var kr = s(Pn || (Pn = d([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), R.bold), Nr = ["darkMode", "className", "as"], Cr = K(function(n) {
  var o = n.darkMode, t = n.className, i = n.as, c = i === void 0 ? "h6" : i, u = X(n, Nr), b = Z(o).theme, g = Q(c).Component;
  return x.createElement(g, I({ className: T(oe, kr, ge[b], t) }, u));
});
Cr.displayName = "Subtitle";
var Dn;
s(Dn || (Dn = d([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function zr(n) {
  var o = function(t, i) {
    if (typeof t != "object" || !t)
      return t;
    var c = t[Symbol.toPrimitive];
    if (c !== void 0) {
      var u = c.call(t, i || "default");
      if (typeof u != "object")
        return u;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (i === "string" ? String : Number)(t);
  }(n, "string");
  return typeof o == "symbol" ? o : o + "";
}
function he(n, o, t) {
  return (o = zr(o)) in n ? Object.defineProperty(n, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[o] = t, n;
}
function ve() {
  return ve = Object.assign ? Object.assign.bind() : function(n) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
    }
    return n;
  }, ve.apply(this, arguments);
}
function Er(n, o) {
  if (n == null)
    return {};
  var t, i, c = function(b, g) {
    if (b == null)
      return {};
    var f, h, p = {}, y = Object.keys(b);
    for (h = 0; h < y.length; h++)
      f = y[h], g.indexOf(f) >= 0 || (p[f] = b[f]);
    return p;
  }(n, o);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(n);
    for (i = 0; i < u.length; i++)
      t = u[i], o.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (c[t] = n[t]);
  }
  return c;
}
function le(n, o) {
  return o || (o = n.slice(0)), Object.freeze(Object.defineProperties(n, { raw: { value: Object.freeze(o) } }));
}
var Fn, Tn, Bn, An, Hn, $r = s(Fn || (Fn = le([`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px `, `px;
  border-bottom: 1px solid;
`])), U[4]), Lr = he(he({}, O.Dark, s(Tn || (Tn = le([`
    background-color: `, `;
    border-color: `, `;
  `])), m.black, m.gray.dark2)), O.Light, s(Bn || (Bn = le([`
    background-color: `, `;
    border-color: `, `;
  `])), m.white, m.gray.light2)), Sr = s(An || (An = le([`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: `, `px;
`])), U[2]), Pr = s(Hn || (Hn = le([`
  margin: auto;
`]))), Mr = ["title", "className", "align", "onClose", "badgeText", "darkMode", "iconSlot"], lt = Oe(function(n, o) {
  var t = n.title, i = n.className, c = n.align, u = c === void 0 ? In.Center : c, b = n.onClose, g = n.badgeText, f = n.darkMode, h = n.iconSlot, p = Er(n, Mr), y = Z(f), z = y.darkMode, C = y.theme;
  return x.createElement(jt, { darkMode: z }, x.createElement("div", ve({ className: T($r, Lr[C], i) }, p, { ref: o }), x.createElement("div", { className: T(Sr, he({}, Pr, u === In.Center)) }, x.createElement(gt, { variant: "mongo", color: "green-base", sizeOverride: 24 }), x.createElement(rt, null, x.createElement("strong", null, t)), g && x.createElement(vt, { variant: "blue" }, g)), !!b && x.createElement(kt, { "aria-label": "Close chat", onClick: b }, h || x.createElement(Ct, null))));
});
lt.displayName = "TitleBar";
var In = { Center: "center", Left: "left" };
function xe(n, o, t) {
  return (o = function(i) {
    var c = function(u, b) {
      if (typeof u != "object" || u === null)
        return u;
      var g = u[Symbol.toPrimitive];
      if (g !== void 0) {
        var f = g.call(u, b || "default");
        if (typeof f != "object")
          return f;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (b === "string" ? String : Number)(u);
    }(i, "string");
    return typeof c == "symbol" ? c : String(c);
  }(o)) in n ? Object.defineProperty(n, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[o] = t, n;
}
function ue() {
  return ue = Object.assign ? Object.assign.bind() : function(n) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
    }
    return n;
  }, ue.apply(this, arguments);
}
function ct(n, o) {
  if (n == null)
    return {};
  var t, i, c = function(b, g) {
    if (b == null)
      return {};
    var f, h, p = {}, y = Object.keys(b);
    for (h = 0; h < y.length; h++)
      f = y[h], g.indexOf(f) >= 0 || (p[f] = b[f]);
    return p;
  }(n, o);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(n);
    for (i = 0; i < u.length; i++)
      t = u[i], o.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (c[t] = n[t]);
  }
  return c;
}
function Y(n, o) {
  return o || (o = n.slice(0)), Object.freeze(Object.defineProperties(n, { raw: { value: Object.freeze(o) } }));
}
var Zn, Rn, Vn, me, _n, Gn, Wn, Xn, qn, Un, Dr = s(Zn || (Zn = Y([`
  width: 100%;
  border: 1px solid;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`]))), Fr = (xe(me = {}, O.Dark, s(Rn || (Rn = Y([`
    border-color: `, `;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
    background-color: `, `;
  `])), m.gray.dark2, m.black)), xe(me, O.Light, s(Vn || (Vn = Y([`
    border-color: `, `;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
    background: `, `;
  `])), m.gray.light2, m.gray.light3)), me), Tr = s(_n || (_n = Y([`
  display: flex;
  flex-direction: column;
  align-items: center;
`]))), Br = s(Gn || (Gn = Y([`
  width: 100%;
  padding: `, `px;
  padding-top: `, `px;
  display: flex;
  justify-content: center;
`])), U[5], U[3]), Ar = s(Wn || (Wn = Y([`
  padding-top: `, `px;
`])), U[2]), Hr = s(Xn || (Xn = Y([`
  width: 100%;
  max-width: `, `px;
`])), Jn.Tablet), ye = mt[yt.Default] + U[3];
s(qn || (qn = Y([`
  padding: 0px `, `px;
`])), ye), s(Un || (Un = Y([`
  // InputBar has padding of: avatarPadding + MessageFeed padding to align with MessageContainer
  padding-left: `, `px;
  padding-right: `, `px;
`])), ye + U[5], ye + U[5]);
var Ir = ["children", "className", "darkMode", "title", "badgeText", "onClose", "iconSlot"], st = Oe(function(n, o) {
  var t = n.children, i = n.className, c = n.darkMode, u = n.title, b = n.badgeText, g = n.onClose, f = n.iconSlot, h = ct(n, Ir), p = Z(c).theme, y = pt().containerWidth, z = ht(t).map(function(C) {
    return wt(C, "InputBar") ? x.createElement("div", { className: T(Br, xe({}, Ar, !!y && y < Jn.Tablet)), key: "input-bar-container" }, x.createElement("div", { className: Hr }, C)) : C;
  });
  return x.createElement("div", ue({ className: T(Dr, Fr[p], i), ref: o }, h), x.createElement(lt, { title: u, badgeText: b, onClose: g, iconSlot: f }), x.createElement("div", { className: Tr }, z));
});
st.displayName = "ChatWindowContents";
var Zr = ["children"], Rr = Oe(function(n, o) {
  var t = n.children, i = ct(n, Zr);
  return x.createElement(bt, null, x.createElement(st, ue({}, i, { ref: o }), t));
});
Rr.displayName = "ChatWindow";
export {
  Rr as A
};
